// ----------------------------------------------------------------------

export default function LoadingButton() {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-text': {
            '& .MuiLoadingButton-endIconPendingEnd': {
              marginRight: 0,
            },
            '& .MuiLoadingButton-startIconPendingStart': {
              marginLeft: 0,
            },
          },
        },
      },
    },
  };
}
